import { useState } from 'react'
import { useParams } from 'react-router-dom'

import NLUDataExamples from '../NLUDataExamples/NLUDataExamples'

import ExamplesHeading from './ExamplesHeading/ExamplesHeading'

import styles from './nlu-data-content.module.scss'

function NLUDataContent() {
    const { tab } = useParams()

    const [search, setSearch] = useState('')

    return (
        <section className={styles.nluDataContent}>
            <div className={styles.nluDataContent__table}>
                <ExamplesHeading search={search} setSearch={setSearch} />
                {tab ? <NLUDataExamples search={search} /> : null}
            </div>
        </section>
    )
}

export default NLUDataContent
